/*
* @Author: babysoft08
* @Date:   2025-03-13 18:02:40
* @Last Modified by:   babysoft08
* @Last Modified time: 2025-03-21 13:10:49
*/

import React from 'react';
import DropZone from './../../components/DropZone/DropZone';
import { SITE_URL } from '../../constants.js';
import uploadImageIcon from '../../images/assets/image-plus.webp';
import UserService from './../../services/UserService/UserService';
import Loader from './../../components/Loader/Loader';

class UploadPoFiles extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			userData: {},
			files: [],
			fileErrors: [],
			uploadedFiles: [],
			isDisabled: true,
			isLoading:0,
			form_error_message:"",
            form_success_message:"",
            showModal : false
		};
		this.userService = new UserService();
	}

	componentDidMount() {
		this.setState((prevState) => ({
			userData: {
				...prevState.userData,
				user_id: localStorage.getItem("techtop_user_id"),
				first_name: localStorage.getItem("techtop_user_first_name"),
				last_name: localStorage.getItem("techtop_user_last_name"),
				company: localStorage.getItem("techtop_user_company"),
				company_logo:
					localStorage.getItem("techtop_user_company_logo") !== "null" && 
					localStorage.getItem("techtop_user_company_logo") !== null && 
					localStorage.getItem("techtop_user_company_logo") !== ""
					? SITE_URL +"files/company_logo/" +localStorage.getItem("techtop_user_company_logo")
					: uploadImageIcon,
			}
		}));
		this.getUploadFiles();
	}

	getUploadFiles() {
		const user_id = localStorage.getItem("techtop_user_id");
		this.userService.getPoFiles(user_id).then(response => {
			var result = response.data;
			if(result.response === 'success') {
				this.setState({ uploadedFiles: result.result })
			}
		});
	}

	sendFiles() {
		const { files, userData } = this.state;
		this.setState({form_error_message:'' ,form_success_message : ''});
		if(files.length > 0) {
			this.setState({isLoading : true , fileErrors :[]});
			this.userService.uploadPoFiles(files, userData.user_id).then(response => {
				this.setState({isLoading : false, files : [], isDisabled : true });
				if(response.data.response === 'success') {
					this.setState({ showModal : true });
				} else {
					this.setState({form_error_message:response.data.message});
				}
				this.getUploadFiles();
			});
		}
	}

	renderUploadedFiles() {
		let { uploadedFiles } = this.state;
		return(
			<React.Fragment>
				<div className="col-md-4">
					<div className="previous-upload-sidebar">
						<h4 className="dark-color1">Previous Uploads</h4>
						<div className="table-responsive">
							<table className="table table-bordered" id="techtop-previous-upload-form">
								<tbody>
									<tr>
										<td>Name</td>
										<td>Date</td>
									</tr>

									{uploadedFiles.length > 0 && (
										<React.Fragment>
											{uploadedFiles.map((file, index) => (
												<tr key={index}>
													<td>
														<a href={file.file_url} target="_blank" rel="noopener noreferrer">{file.po_file}</a>
													</td>
													<td>{file.date}</td>
												</tr>
											))}
										</React.Fragment>
									)}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}

	renderDropZone() {
		let { files, fileErrors, isDisabled } = this.state;
		return(
			<React.Fragment>
				<div className="col-md-8">
					<form className="form">
						<h4 className="dark-color1 text-center">File Upload</h4>
						<DropZone files={files} setFiles={this.handleFileUpload} fileErrors={ fileErrors } setFileErrors={this.handleFileError}/>
						<h4 className="dark-color1 text-center pt-3"> File List </h4>
						{this.renderFileError()}
						<ul className="file-list-div">
							{files.map((file, index) => (
								<li key={index}>
									{this.getFileIcon(file.name)}&nbsp; {file.name}
								</li>
							))}
						</ul>

						<button type="button" className="submit-po-btn" onClick={(e) => this.sendFiles(e)} disabled={isDisabled} style={{ backgroundColor: isDisabled ? "#ccc" : "#125d67", cursor: isDisabled ? "not-allowed" : "pointer"}}>Submit PO</button>
					</form>
				</div>
			</React.Fragment>
		)
	}

	handleFileUpload = (files) => {
		this.setState({ files });
		this.setState( { isDisabled : (files.length > 0) ? false : true });
	};

	handleFileError = (errors) => {
		this.setState({ fileErrors: errors});
	}

	getFileIcon = (fileName) => {
	    const ext = fileName.split(".").pop().toLowerCase();
	    
	    switch (ext) {
	      case "pdf":
	        return <span className="file-icon pdf">📄</span>;
	      case "xlsx":
	      case "xls":
	        return <span className="file-icon excel">📊</span>;
	      case "jpg":
	      case "jpeg":
	      case "png":
	      case "tiff":
	      case "tif":
	        return <span className="file-icon image">🖼️</span>;
	      default:
	        return <span className="file-icon default">📁</span>;
	    }
	};

	renderFormError() {
		const { form_error_message } = this.state;
		return(
			<React.Fragment>
				{(form_error_message) && 
					(
						<React.Fragment>
							<div className="alert alert-danger text-center mt-2" role="alert">
								<h4 className="alert-heading fw-bold"> Error !</h4>
								<p>{ form_error_message }</p>
							</div>
						</React.Fragment>
					)
				}
			</React.Fragment>
		)
	}

	renderFormSuccess() {
		const { form_success_message } = this.state;
		return(
			<React.Fragment>
				{(form_success_message) && 
					(
						<React.Fragment>
							<div className="alert alert-success text-center mt-2" role="alert">
								<p><h4 className="alert-heading fw-bold"> Success !</h4> { form_success_message }</p>
							</div>
						</React.Fragment>
					)
				}
			</React.Fragment>
		)
	}

	componentDidUpdate(_, prevState) {
	    if (this.state.showModal !== prevState.showModal) {
	        document.body.style.overflow = this.state.showModal ? 'hidden' : 'auto';
	    }
	}

	renderFileError() {
		let { fileErrors } = this.state;
		return(
			<React.Fragment>
				{(fileErrors.length > 0) && 
					(
						<React.Fragment>
							<div className="alert alert-danger mt-2" role="alert">
								<ul>
									{fileErrors.map((value, index) => (
										<li key={index}>{value}</li>
									))}
								</ul>
							</div>
						</React.Fragment>
					)
				}
			</React.Fragment>
		)
	}

	renderModal() {
		let { showModal } = this.state
		return(
			<React.Fragment>
				{showModal && <div className="modal-backdrop fade show"></div>} {/* Overlay */}
				<div 
	                className={`modal fade ${showModal ? 'show' : ''}`} 
	                id="submitPoModal" 
	                tabIndex="-1" 
	                aria-labelledby="exampleModalLabel" 
	                aria-hidden={!showModal} 
	                style={{ display: showModal ? 'block' : 'none' }}
	            >
					<div className="modal-dialog modal-dialog-centered">
						<div className="modal-content">
							<div className="modal-body">
								<p> Thank you! Your purchase order has been successfully submitted to{" "} <a href="toEmail:orders@techtopind.com"><strong>orders@techtopind.com.</strong></a></p>
								<p> Our Customer Service team will review and process your order promptly.</p>
								<p>You’ll receive a confirmation email shortly.</p>
								<p>We appreciate you using our Upload PO feature!</p>
								<button type="button" className="done-btn" onClick={() => this.setState({ showModal: false })}>Done</button>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}

	render() {
		const { isLoading, userData, files } = this.state;
		return (
			<main className="techtop-middle-div">
	        	<section className="techtop-upload-po-section py-5">
	          		<div className="container">
	            		{this.renderFormError()}
	            		{this.renderFormSuccess()}
	            		<div className="row">
	              			<div className="col-md-12">
	              				<Loader isLoading={isLoading} message="Processing..."/>
	              				<div className="techtop-default-title2 mb-4">
	              					<div className="row">
	              						<div className="col-6">
	              							<h1 className="m-0 dark-color1">Upload PO</h1>
	              						</div>
	              					<div className="col-6">
	              						<h2 className="m-0 dark-color1 text-end">
	              							{userData.company}
	              						</h2>
	              					</div>
	              				</div>
	              			</div>
	              			<div id="ip-upload-po-form">
	              				<div className="row">
	              					{this.renderUploadedFiles()}
	              					{this.renderDropZone()}
	              				</div>
	              			</div>
	              		</div>
	              	</div>
	              </div>
	            </section>
	            {this.renderModal()}
	        </main>
	    );
	}
}
export default UploadPoFiles;